import axios from "axios";

export class GetWhiteBrandConfig {
  constructor(
    private readonly frontend
  ) {}

  async run(domain: string) {
    const args = {
      domain: domain,
    }
    const response = await axios.get(process.env.VUE_APP_API_ENDPOINT + '/get_white_brand_config/', { params: args })
    if (response.data.colors) {
      // Apply colors to Vuetify theme
      const colors = response.data.colors
      Object.keys(colors).forEach(key => {
        if (this.frontend.$vuetify.theme.themes.light[key] !== undefined) {
          this.frontend.$vuetify.theme.themes.light[key] = colors[key]
        }
      })
      this.frontend.whiteBrandColors = colors
    }
    // Store crisp chat config
    this.frontend.disableCrispChat = response.data.disable_crisp_chat || false
    this.frontend.disableCrispChatClients = response.data.disable_crisp_chat_clients || false

    // Store background image
    this.frontend.whiteBrandBgImage = response.data.bg_image || null;
    (window as any).whiteBrandBgImage = response.data.bg_image || null

    // Hide Crisp chat if disabled for this white brand domain (pre-login)
    // Post-login, me.js re-evaluates based on user role and may show it for owners
    if (this.frontend.disableCrispChat || this.frontend.disableCrispChatClients) {
      (window as any).execWithCrispReady(() => {
        (window as any).$crisp.push(["do", "chat:hide"])
      })
    }
  }
}
